export const publicationDate = (inputDate, language = 'en') => {
  const translations = {
    en: {
      today: 'Today',
      yesterday: 'Yesterday',
      hoursAgo: (h) => `${h} hour${h === 1 ? '' : 's'} ago`,
      minutesAgo: (m) => `${m} minute${m === 1 ? '' : 's'} ago`,
      daysAgo: (d) => `${d} day${d === 1 ? '' : 's'} ago`,
    },
    es: {
      today: 'Hoy',
      yesterday: 'Ayer',
      hoursAgo: (h) => `Hace ${h} hora${h === 1 ? '' : 's'}`,
      minutesAgo: (m) => `Hace ${m} minuto${m === 1 ? '' : 's'}`,
      daysAgo: (d) => `Hace ${d} día${d === 1 ? '' : 's'}`,
    },
  };

  if (!inputDate) return '';

  let publicationDate;

  // Caso 1: ya es un objeto Date
  if (inputDate instanceof Date) {
    publicationDate = inputDate;
  }

  // Caso 2: string relativo (“6 hours ago”, “5 days ago”, “30 minutes ago”)
  else if (typeof inputDate === 'string' && /\b\d+\s+(minutes?|hours?|days?)\s+ago\b/i.test(inputDate)) {
    const [, amountStr, unit] = inputDate.match(/(\d+)\s+(minutes?|hours?|days?)\s+ago/i);
    const amount = parseInt(amountStr, 10);
    publicationDate = new Date();

    if (/minute/i.test(unit)) publicationDate.setMinutes(publicationDate.getMinutes() - amount);
    else if (/hour/i.test(unit)) publicationDate.setHours(publicationDate.getHours() - amount);
    else if (/day/i.test(unit)) publicationDate.setDate(publicationDate.getDate() - amount);
  }

  // Caso 3: ISO string u otro formato válido
  else if (typeof inputDate === 'string') {
    publicationDate = new Date(inputDate);
  }

  else return '';

  if (isNaN(publicationDate)) return '';

  const now = new Date();
  const diffMs = now - publicationDate;
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMinutes / 60);
  const diffDays = Math.floor(diffHours / 24);

  const t = translations[language] || translations['en'];

  if (diffMinutes < 60) return t.minutesAgo(diffMinutes || 1);
  if (diffHours < 24) return t.hoursAgo(diffHours);
  if (diffDays === 0) return t.today;
  if (diffDays === 1) return t.yesterday;
  return t.daysAgo(diffDays);
};
